export const API_URL = process.env.REACT_APP_API_URL
export const DROPBOX_TOKEN = process.env.REACT_APP_DROPBOX_TOKEN
export const DROPBOX_REFRESH_TOKEN = process.env.REACT_APP_DROPBOX_REFRESH_TOKEN
export const DROPBOX_CLIENT_ID = process.env.REACT_APP_DROPBOX_CLIENT_ID
export const DROPBOX_CLIENT_SECRET = process.env.REACT_APP_DROPBOX_CLIENT_SECRET
export const DROPBOX_PATH = process.env.REACT_APP_DROPBOX_PATH